import { value } from './value';

interface IResult {
    label: string;
    span?: string;
    value: string | number;
}

export default function parseValue(val: value): IResult {
    let value: string | number;
    let label: string;
    let span: string | undefined;

    switch (typeof val) {
        case 'object':
            value = val.value;
            label = val.label;
            span = val.span;
            break;
        case 'number':
            value = val;
            label = String(val);
            break;
        default:
            value = val;
            label = val;
            break;
    }

    return { value, label, span };
}
